import React, { Component } from 'react'
import CardPartidoSquare from '../CardPartidoSquare'
import './_styles.scss'
import FlagSmall from '../FlagSmall'
import Asset from '../../../../../requests/apa/Asset'
import Utils from '../../../../../utils/Utils'
import Translator from '../../../../../requests/apa/Translator'
import { matchCompleted } from '../../../constants'

class FinalContent extends Component {
    getTeam(matches, type) {
        if (!matches || !matches.length) return null;
        
        const match = matches[0];
        
        if (!match || !match.homeTeam || !match.awayTeam || match.status !== matchCompleted) return null;

        const homeScore = match.homeTeam.score;
        const awayScore = match.awayTeam.score;

        if (homeScore === awayScore) {
            return null;
        }

        if (homeScore > awayScore) {
            return type === 'winner' ? match.homeTeam : match.awayTeam;
        }

        if (awayScore > homeScore) {
            return type === 'winner' ? match.awayTeam : match.homeTeam;
        }

        return null;
    }

    renderDefaultTeam() {
        return (
            <FlagSmall
                countryName='Por definir'
                iconSize='large'
            />
        )
    }

    renderTeam(matches, type, isThirdPlace = false) {
        if (!matches || !matches.length) return null;

        const team = this.getTeam(matches, type, isThirdPlace)

        if (team) {
            return (
                <FlagSmall
                    flagUrl={team.flagUrl}
                    countryName={team.name}
                    iconSize='large'
                />
            )
        } else {
            return this.renderDefaultTeam()
        }
    }

    renderMatches(round) {
        const { path, liveScoresMap = {} } = this.props
        if (!round || !Array.isArray(round) || round.length < 1) return null

        return round && round.map((item, index) => {
            const match = item
            return (
                <CardPartidoSquare
                    key={index}
                    time={match.time}
                    timezone={match.timezone}
                    homeTeam={match.homeTeam}
                    awayTeam={match.awayTeam}
                    venue={match.venue}
                    matchId={match.id}
                    status={match.status}
                    scheduledAt={match.scheduledAt}
                    broadcast={match.broadcast}
                    matchProgress={match.matchProgress}
                    date={match.scheduledAt}
                    liveScore={liveScoresMap[match.id]}
                    path={path}
                    liveScore={liveScoresMap[match.id]}
                />
            )
        })
    }

  render () {
    const { phase = '', matches = [], thirdPlaceMatch = [] } = this.props

    return (
      <div className='final-content'>
        {/* ── Left column: final match ── */}
        <div className='final-content__col final-content__col--left'>
            {/* ── Horizontal lines ── */}
            <div className='final-content__line-horizontal'>
                <img src={Asset.get('eventodeportivo_carruseletapas_imagen_linea2','')} />
            </div>

            <div className='final-content__match-container'>
                <div className='final-content__match-title'>{Utils.cutPlayerString(Translator.get(`eventodeportivo_carruseletapas_texto_titulo1_${phase}`),22)}</div>
                { this.renderMatches(matches) }
            
            </div>
        </div>

        {/* ── Right column: Podium ── */}
        <div className='final-content__col final-content__col--right'>
            <div className='final-content__places-container'>
                <div className='final-content__places-title'>{Utils.cutPlayerString(Translator.get('eventodeportivo_carruseletapas_ficha_texto_titulo_resultados'), 28)}</div>
                <div className='final-content__podium'>
                    <div className='final-content__place final-content__place--second'>
                        
                        { this.renderTeam(matches, 'loser') }
                        
                        <div className='final-content__place-image'>
                            <img src={Asset.get('eventodeportivo_carruseletapas_ficha_imagen_2lugar', '')} />
                        </div>
                        <div className='final-content__place-description'>{Utils.cutPlayerString(Translator.get('eventodeportivo_carruseletapas_ficha_texto_2lugar'), 8)}</div>
                    </div>

                    <div className='final-content__place final-content__place--first'>
                        
                        { this.renderTeam(matches, 'winner') }

                        <div className='final-content__place-image'>
                            <img src={Asset.get('eventodeportivo_carruseletapas_ficha_imagen_1lugar', '')} />
                        </div>
                        <div className='final-content__place-description'>{Utils.cutPlayerString(Translator.get('eventodeportivo_carruseletapas_ficha_texto_1lugar'), 8)}</div>
                    </div>

                    <div className='final-content__place final-content__place--third'>
                        
                        { this.renderTeam(thirdPlaceMatch, 'winner') }
                        
                        <div className='final-content__place-image'>
                            <img src={Asset.get('eventodeportivo_carruseletapas_ficha_imagen_3lugar', '')} />
                        </div>
                        <div className='final-content__place-description'>{Utils.cutPlayerString(Translator.get('eventodeportivo_carruseletapas_ficha_texto_3lugar'), 8)}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
  }
}

export default FinalContent



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Partidos/Components/FinalContent/index.jsx